export interface IWrap {
    enabled: boolean;
    timeoutSeconds: number;
    enableWrapupTimerReset: boolean;
    maxNumberOfWrapupResets: number;
    completionCodes: string[];
}

export const DefaultWrap: IWrap = {
    enabled: false,
    timeoutSeconds: 0,
    enableWrapupTimerReset: false,
    maxNumberOfWrapupResets: 0,
    completionCodes: [],
};

export interface IWrapState {
    code: string;
    notes: string;
    summary: boolean;
    noSummaryMessage: string;
}
